import type { FaireProductEntity } from "../../entity_types/product";

export const p_yq9a7etx55: FaireProductEntity = {
  token: "p_yq9a7etx55",
  type: "product",
  name: "Shit Happens Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/9df09d35eed5e61522b18843865c6a8978d3a5953a599ae4f320a553d5a2e48c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd691d7e1dee292fd12696b4b674fc9a34ceee8cbdd106911e60fdb2ddb8da06.jpeg",
    "https://cdn.faire.com/fastly/b6ed5124b58724d1efadd0c5b8250fb1c8f25925dc95877995f472b944ff78a3.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5647030c53b55a1051c0f48dbaaccf01497e0d96e77c4ebca845cc013701c77f.jpeg",
    "https://cdn.faire.com/fastly/53695368096f55459a0ce86abb362dd84e912663dc60baec1f0c4dd7c44cd6d3.jpeg"
  ],
  priceDollars: 3.38,
  description: "When life throws a shitball (or a whole shitstorm), these socks have your back. Because sometimes, shit just happens—and the best you can do is keep moving forward, one comfy step at a time.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:25.023Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
